import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';

enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule)
  .then((success) => {})
  .catch((err) => console.error(err));


// WEBPACK FOOTER //
// ./src/app/main.ts